import {
  CLIENTS_FETCH,
  CLIENTS_UPDATE_CLIENT,
  CLIENTS_RESET_DATA,
} from 'modules/Referral/ReferralClients/types'

export const actionFetchClients = (props) => ({
  type: CLIENTS_FETCH,
  payload: props,
})

export const actionUpdateClient = (props) => ({
  type: CLIENTS_UPDATE_CLIENT,
  payload: props,
})

export const actionResetClients = () => ({
  type: CLIENTS_RESET_DATA,
})
